import { useEffect, useState } from "react";

export const useEventSteps = (isOpen: boolean, initialStep = 1) => {
  // Keep track of the current step (there are 5 steps in total)
  // When the modal is opened/closed, we want to reset the step to 1
  const totalSteps = 5;
  const [currentStep, setCurrentStep] = useState(initialStep);
  useEffect(() => setCurrentStep(initialStep), [initialStep, isOpen]);
  const [isVirtual, setIsVirtual] = useState(false);

  const handleNextClick = () => {
    const offset = isVirtual && currentStep === 1 ? 2 : 1;
    setCurrentStep(Math.min(currentStep + offset, totalSteps));
  };

  const handlePreviousClick = () => {
    const offset = isVirtual && currentStep === 3 ? 2 : 1;
    setCurrentStep(Math.max(currentStep - offset, 1));
  };

  const handleJumpToStepClick = (step: number) =>
    setCurrentStep(Math.max(Math.min(step, totalSteps), 1));

  return {
    currentStep,
    totalSteps,
    handleNextClick,
    handlePreviousClick,
    handleJumpToStepClick,
    setCurrentStep,
    isVirtual,
    setIsVirtual,
  };
};
